import React from "react";
import Icon from "./Icon";
export default function Music(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5V4.58333L19.25 2.75V14.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.25C7.01878 19.25 8.25 18.0188 8.25 16.5C8.25 14.9812 7.01878 13.75 5.5 13.75C3.98122 13.75 2.75 14.9812 2.75 16.5C2.75 18.0188 3.98122 19.25 5.5 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.4167C18.0188 17.4167 19.25 16.1854 19.25 14.6667C19.25 13.1479 18.0188 11.9167 16.5 11.9167C14.9812 11.9167 13.75 13.1479 13.75 14.6667C13.75 16.1854 14.9812 17.4167 16.5 17.4167Z"
  }));
}
Music.displayname = "Music";
//# sourceMappingURL=Music.js.map